/**
 * This function returns another function that simply returns whatever input it's given. However, it
 * also checks that the input matches the original wrapTypeWithReadonly's generic, while maintaining
 * strict "const" like typing.
 */
export function wrapTypeWithReadonly() {
    return (input) => {
        return input;
    };
}
